
import { createContext, Dispatch, FC, ReactNode, SetStateAction, useContext, useEffect  } from 'react';

import { OnlineFormEventType, OnlineFormEventSubType  } from 'src/api/zrm';
import { useAnalyticsContext } from 'src/contexts/AnalyticsContext';
import { useFormStepperDialogContext } from 'src/contexts/FormStepperDialogContext';
import BlancoNorwayForm from 'src/types/BlancoNorway/form/BlancoNorwayForm';
import BlancoSwedenForm from 'src/types/BlancoSweden/form/BlancoSwedenForm';
import MortgageNorwayForm from 'src/types/MortgageNorway/form/MortgageNorwayForm';
import deepUpdate from 'src/utils/lodashLike/deepUpdate';


import { useSharedApiFormContext } from './SharedApiFormContext';
import { useSharedDataContext } from '../SharedDataContext';

type BlancoForm = BlancoSwedenForm | BlancoNorwayForm;
type MortgageForm = MortgageNorwayForm;

interface SharedDataFormContextProps {
  formData: BlancoForm;
  updateFormSection: (key: string, values: any) => void;
  updateFormField: (path: string, value: any) => void;
  saveForm: () => void;
 
}

interface SharedDataFormContextProviderProps {
  defaultData: BlancoForm | MortgageForm;
  children: ReactNode;
}

const SharedDataFormContext = createContext<SharedDataFormContextProps>({
  formData: null,
  updateFormSection: () => { },
  saveForm: () => { },
  updateFormField: () => { },
});

interface DataFormType {
  formData: BlancoForm | MortgageForm;
  setFormData: Dispatch<SetStateAction<BlancoForm | MortgageForm>>;
}

const SharedDataFormContextProvider: FC<SharedDataFormContextProviderProps> = (props) => {
  const { defaultData, children } = props;


  const { formData, setFormData }: DataFormType = useSharedDataContext();
  const { preparedQuickApp } = useSharedDataContext();

  const { closeDialog } = useFormStepperDialogContext();
  const { saveSharedForm } = useSharedApiFormContext();

  const { analyticsAddEvent } = useAnalyticsContext();


  const updateFormSection = (key: string, values: any) => {

    analyticsAddEvent(OnlineFormEventType.UPDATE, OnlineFormEventSubType.SUCCESS, { section_name: key });
    setFormData((prev) => {
      const temp = { ...prev };
      deepUpdate(temp, key, values);

      return temp;
    });

  };

  const updateFormField = (path: string, value: any) => {
    setFormData((prev) => {
      const temp = { ...prev };
      deepUpdate(temp, path, value);

      return temp;
    });
  };
  const saveForm = async () => {
    
    const mappedData = preparedQuickApp;
  
    const success = await saveSharedForm(mappedData);

    if (success) { closeDialog({ appCreated: true }); }
  };


  useEffect(() => {
    setFormData(defaultData);
  }, []);

  return (
    <SharedDataFormContext.Provider
      value={{
        formData,
        updateFormSection,
        updateFormField,
        saveForm,
      }}
    >
      {children}
    </SharedDataFormContext.Provider>
  );
};

const useSharedDataFormContext = () => useContext(SharedDataFormContext);

export { SharedDataFormContextProvider, useSharedDataFormContext };
